const styles = theme => ({
  root:{
    fontSize: '80%',
    [theme.breakpoints.up('sm')]: {
      fontSize: '100%'
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/layouts/styles.js